export enum AgentAvatarReaction {
    HAPPY = "happy",
    LOVE = "love",
    LAUGH = "laugh",
    WINK = "wink",
    EXCITED = "excited",
    PROUD = "proud",
    CURIOUS = "curious",
    SURPRISED = "surprised",
    CONFUSED = "confused",
    SUSPICIOUS = "suspicious",
    ANGRY = "angry",
    SAD = "sad",
    SCARED = "scared",
    SHY = "shy",
    BORED = "bored",
    SLEEPY = "sleepy",
    NOD = "nod",
    NO = "no",
    WAVE = "wave"
}
